import { useSelector, useDispatch } from 'react-redux';
import * as ToastActions from 'app/redux/actions/ToastActions';

export function useToast(props={}) {
    
    const toasts = useSelector((store) => store.toast.items);
    const dispatch = useDispatch();

    const show = (type, message, params = {}) =>{
        let id = 1, data = { type, message, params: {...props,...params} };
        if( toasts[id] ){
            dispatch(ToastActions.remove(id));
            setTimeout(()=>dispatch(ToastActions.add(id,data)),100);    
        } else
            dispatch(ToastActions.add(id,data));
    }

    return { 
        show,
        success : (text, params={}) => show('success',text,params), 
        error   : (text, params={}) => show('error',text),
        warning : (text, params={}) => show('warning',text,params),
        info    : (text, params={}) => show('info',text,params), 
    };
}